import React from 'react';
import AvatarImage from '../../../elements/AvatarImage';

const SidemenuSummary = (props) => {
  const { companyName, balance, avatarUrl } = props;

  return (
    <div className="summary">
      <AvatarImage className="avatar" src={avatarUrl} alt="" height="64" width="64" />
      <div className="details">
        <span className="name">{companyName}</span>
        <span className="balance">Balance: ${balance}</span>
      </div>
    </div>
  );
};

export { SidemenuSummary };
